module.exports = __webpack_public_path__ + "static/media/desk.b7d88500.jpeg";